<template>
  <div>
    <div class="row sticky-button">
      <div class="px-3">
        <div class="form-group has-label">
          <label class="row">
            <h4 class="d-flex align-self-center">
              {{ $t('sigatoka.leaves') }}:
            </h4>
            <strong class="d-flex align-self-center pl-2 pt-3">{{
              model.leaf_count
            }}</strong>
          </label>
        </div>
      </div>
    </div>
    <div
      v-for="(leaf, leafIndex) in model.leafs"
      :key="leafIndex"
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
    >
      <div class="row px-3" style="width: 90%">
        <div class="col-12 col-sm-5 col-md-2 col-lg-2 col-xl-2">
          <fg-input
            type="number"
            @keypress="validateInput"
            @input="handleInput($event, leafIndex)"
            v-model="leaf.number"
            :label="`${$t('sigatoka.leaf')} ${leaf.number || ''}`"
            :class="`required-leaf-${leafIndex}`"
          />
        </div>
        <div
          class="col-12 px-3 ml-3 mb-1 shadow-sm"
          style="border: 0.5px solid #6ba6524d"
        >
          <div class="row">
            <div
              v-for="(st, stIndex) in leaf.status"
              :key="stIndex"
              class="col-auto d-flex align-items-end"
            >
              <fg-input
                type="number"
                @keypress="validateInput"
                v-model="leaf.status[stIndex]"
                :label="`${$t('sigatoka.stage')} ${stIndex + 1}: `"
                :class="`required-estadio-${stIndex}`"
              ></fg-input>
              <div class="p-1 d-flex align-items-center">
                <div class="btn-group mb-2" role="group">
                  <button
                    class="btn btn-danger btn-sm custom-shadow-btn mr-1"
                    @click.prevent="handleDelete(leafIndex, st, true, stIndex)"
                  >
                    <em class="fa fa-minus"></em>
                  </button>
                  <button
                    v-if="stIndex + 1 === leaf.status.length"
                    @click.prevent="handleValuePlus(leafIndex)"
                    class="btn btn-success btn-sm custom-shadow-btn"
                  >
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-3 ml-3 my-0 py-0 form-group has-label">
          <label class="row my-0 py-0">
            <h5 class="d-flex align-self-center my-1 py-0">
              {{ $t('sigatoka.gross_sum_values') }}:
            </h5>
          </label>
        </div>
        <div
          class="col-12 px-3 ml-3 mb-4 shadow-sm"
          style="border: 0.5px solid #6ba6524d"
        >
          <div class="row">
            <div
              class="col-auto"
              v-for="(p, pIndex) in leaf.plus"
              :key="pIndex"
            >
              <div class="row">
                <div class="col-auto">
                  <fg-input
                    @keypress="validateInput"
                    type="number"
                    v-model="leaf.minus[pIndex]"
                    label="-"
                    label-classes="font-weight-bold text-dark mb-1"
                    :class="`mr-5 required-plus-${pIndex}`"
                  />
                  <fg-input
                    @keypress="validateInput"
                    type="number"
                    v-model="leaf.plus[pIndex]"
                    label="+"
                    label-classes="font-weight-bold text-dark mb-1"
                    :class="`mr-5 required-minus-${pIndex}`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-3 col-1 col-sm-1 col-lg-1 d-flex align-items-center">
        <div class="btn-group" role="group">
          <button
            class="btn btn-danger custom-shadow-btn mr-2"
            @click.prevent="handleDelete(leafIndex, leaf.number)"
          >
            <em class="fa fa-minus"></em>
          </button>

          <button
            v-if="leafIndex + 1 === model.leaf_count"
            @click.prevent="handleLeafPlus()"
            class="btn btn-success custom-shadow-btn"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  data() {
    return {
      model: {
        leaf_ids: [],
        status_ids: [],
        gross_ids: [],
        deleted_leaf_ids: [],
        deleted_status_ids: [],
        deleted_gross_ids: [],
        leaf_count: 3,
        leafs: [
          {
            number: 1,
            status: [null],
            plus: [null],
            minus: [null],
          },
          {
            number: 2,
            status: [null],
            plus: [null],
            minus: [null],
          },
          {
            number: 3,
            status: [null],
            plus: [null],
            minus: [null],
          },
        ],
      },
    };
  },
  methods: {
    validateInput(event) {
      const input = String.fromCharCode(event.which);
      if (!/[0-9,.]/.test(input)) event.preventDefault();
    },
    handleInput(value, leafIndex) {
      let val = value ? value.toString() : '';
      if (val.length > 2) {
        val = val.slice(0, 2);
      }
      this.model.leafs[leafIndex].number = val;
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          for (let i = 0; i < this.model.leafs.length; i++) {
            if (!isset(this.model.leafs[i].number))
              return this.validationInputsRequired(`leaf-${i}`);
            for (let j = 0; j < this.model.leafs[i].status.length; j++) {
              if (!isset(this.model.leafs[i].status[j]))
                return this.validationInputsRequired(`estadio-${j}`);
            }
            for (let k = 0; k < this.model.leafs[i].plus.length; k++) {
              if (!isset(this.model.leafs[i].plus[k]))
                return this.validationInputsRequired(`plus-${k}`);
              if (!isset(this.model.leafs[i].minus[k]))
                return this.validationInputsRequired(`minus-${k}`);
            }
          }
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
    handleDelete(index, value, isValue = false, otherIndex = null) {
      if (value) {
        SweetAlert.delete(i18n.t('common_words.row')).then((result) => {
          if (result.value) {
            if (isValue) this.handleValueMinus(index, otherIndex);
            else this.handleLeafMinus(index);
          }
        });
      } else {
        if (isValue) this.handleValueMinus(index, otherIndex);
        else this.handleLeafMinus(index);
      }
    },
    handleLeafPlus() {
      this.model.leaf_count++;
      this.model.leafs.push({
        number: null,
        status: [null],
        plus: [null],
        minus: [null],
      });
    },
    handleLeafMinus(leafIndex) {
      const min = 1;
      if (this.model.leaf_count > min) {
        this.model.leaf_count--;
        this.model.leafs.splice(leafIndex, 1);
        if (this.model.leaf_ids[leafIndex])
          this.model.deleted_leaf_ids.push(this.model.leaf_ids[leafIndex]);
      }
    },
    handleValuePlus(leafIndex) {
      this.model.leafs[leafIndex].status.push(null);
      this.model.leafs[leafIndex].plus.push(null);
      this.model.leafs[leafIndex].minus.push(null);
    },
    handleValueMinus(leafIndex, valueIndex) {
      this.model.leafs[leafIndex].status.splice(valueIndex, 1);
      this.model.leafs[leafIndex].plus.splice(valueIndex, 1);
      this.model.leafs[leafIndex].minus.splice(valueIndex, 1);
      if (this.model.status_ids[leafIndex][valueIndex])
        this.model.deleted_status_ids.push(
          this.model.status_ids[leafIndex][valueIndex]
        );
      if (this.model.gross_ids[leafIndex][valueIndex])
        this.model.deleted_gross_ids.push(
          this.model.gross_ids[leafIndex][valueIndex]
        );
    },
  },
  mounted() {
    const editForm = JSON.parse(sessionStorage.getItem('editForm'));
    if (!this.isUpdate() || !editForm) return;
    const bws = editForm.sigatoka_config_bws;
    this.model.leaf_count = bws.length;
    this.model.leaf_ids = bws.map((bw) => bw.id);
    this.model.status_ids = bws.map((bw) =>
      bw.sigatoka_config_bw_statuses.map((s) => s.id)
    );
    this.model.gross_ids = bws.map((bw) =>
      bw.sigatoka_config_bw_grosses.map((g) => g.id)
    );
    this.model.leafs = bws.map((bw) => ({
      number: bw.leaf,
      status: bw.sigatoka_config_bw_statuses.map((s) => s.status),
      plus: bw.sigatoka_config_bw_grosses.map((g) => g.plus),
      minus: bw.sigatoka_config_bw_grosses.map((g) => g.minus),
    }));
  },
};
</script>
